/*
 * reveal.js -- entrance animace komponentove knihovny (plan 08-02, KOMP-03).
 *
 * CO TENHLE MODUL JE A CO NENI
 *
 * NENI to nositel viditelnosti obsahu. Bez skriptu je kazdy `.reveal` prvek
 * plne viditelny -- CSS pravidla, ktera ho schovavaji, jsou v components.css
 * scopovana pod `html.js`, takze bez inline `jsclass` skriptu vubec neplati
 * (kontrakt B). Tenhle modul je ENHANCEMENT: rozhoduje jen o tom, KDY se
 * schovany prvek prepne do ciloveho stavu.
 *
 * DVA NEZAVISLE SIGNALY, KTERE SE CASTO PLETOU
 *
 *   `html.reveal-ready`     "modul se spustil" -- pridava se na PRVNIM radku
 *                           `init()`, pred jakymkoli early-return. CSS na
 *                           nem visi svuj vlastni CASOVY fallback
 *                           (`html.js:not(.reveal-ready)` -> po 2 s odkryj
 *                           vse), takze trida NESMI cekat na dobehnuti IO
 *                           ani timeoutu -- to by fallback zrusila prave
 *                           v okamziku, kdy modul jeste nic neudelal.
 *   `data-reveal-ready="1"` "tenhle konkretni prvek smi do ciloveho stavu"
 *                           -- per prvek, z IO nebo z 1,2s fallbacku.
 *
 * Analogie je `menu-ready` z 07-03/07-07 s JEDNIM zamernym rozdilem: menu
 * pridava tridu az na KONCI `init()` (hamburger nesmi byt viditelny drive,
 * nez ma obsluhu), reveal ji pridava na ZACATKU (dokud modul nebezi, ma
 * platit CSS fallback; kdyby trida prisla az na konci, byl by mezi
 * spustenim modulu a jeho dokoncenim okamzik, kdy neplati ani jedna
 * pojistka). Obojí je totez pravidlo: trida znaci stav, ktery CSS potrebuje
 * odlisit, ne "hotovo".
 *
 * PROC FALLBACK EXISTUJE DVAKRAT (JS 1,2 s + CSS 2 s)
 *
 * Kazdy resi jinou poruchu a jeden druhy nenahradi:
 *   - JS `setTimeout` 1,2 s (rozhodnuti #15 CONTEXT.md -- jednotny pro celou
 *     stranku od `init()`) resi prvky, na ktere IO nikdy nezafiruje: sekce
 *     mimo vyrez, kterou navstevnik neodroluje, prvek ve skrytem tabu,
 *     stranka kratsi nez obsah.
 *   - CSS animace 2 s (components.css, `html.js:not(.reveal-ready)`) resi
 *     stav, kdy tenhle soubor VUBEC NEDOBEHNE -- bundl se nenacetl (sit,
 *     CSP, firemni proxy) nebo `init()` vyhodil vyjimku. Zadny JS timeout
 *     tehdy neexistuje, protoze neexistuje zadny JS.
 * CSS okno je delsi schvalne: v beznem behu ma vyhrat JS cesta (1,2 s),
 * CSS je az pojistka pojistky.
 *
 * PROC SELEKTOR OBSAHUJE I VARIANTY
 *
 * CSS schovava `.reveal`, `.reveal--left` i `.reveal--blur`. Kdyby modul
 * sbiral jen `.reveal`, staci jediny prvek s variantou bez zakladni tridy
 * (rucne psany markup, cizi sablona) a zustal by schovany az do CSS
 * fallbacku. Mnozina prvku, ktere CSS schovava, a mnozina, kterou modul
 * odkryva, musi byt tataz -- jinak vznikne presne ta hrozba, kvuli ktere
 * je cely tenhle dvouvrstvy mechanismus postaveny (T-08-02-02).
 *
 * BEZPECNOST (threat model 08-02)
 * Zadny `innerHTML`, zadny `eval`, zadna interpolace vstupu -- jen
 * `classList.add` a `setAttribute` s konstantami (ASVS V5, tataz disciplina
 * jako moduly F0.5). Modul nesaha na `document.body.classList`: stavy tela
 * jsou vyhradne kontrakt `state.js` a reveal zadny novy nepotrebuje
 * (`reveal-ready` zije na <html>, stejne jako `menu-ready`).
 */

import { REVEAL_IO_THRESHOLD, REVEAL_ROOT_MARGIN, REVEAL_FALLBACK_MS } from './reveal-timing.js';
import { guard } from './resize-guard.js';

/** Atribut, kterym CSS pozna prvek pripraveny do ciloveho stavu. */
const READY_ATTR = 'data-reveal-ready';

/** Trida na <html>: "reveal modul se spustil" (analogie `menu-ready`). */
const READY_CLASS = 'reveal-ready';

/*
 * Trida na <html> pri SELHANI modulu (08-16b, #69). CSS na ni ma pravidlo
 * `opacity: 1`, ktere lezi ZA skryvacim pravidlem `html.js .reveal`, takze
 * pri konfliktu vyhrava -- treti, na JS nezavisla cesta k odkryti obsahu.
 */
const FAILED_CLASS = 'reveal-failed';

/**
 * Prvky, ktere modul sleduje. Shoda s mnozinou schovavanou v
 * components.css je POVINNA, ne kosmeticka -- viz docblok vyse.
 */
const TARGET_SELECTOR = '.reveal, .reveal--left, .reveal--blur';

/**
 * Podil prvku ve vyrezu a odsazeni korenu, pri kterem se ma odkryt --
 * sdileno s HP systemem (hp2026.js) pres `reveal-timing.js` (nalez
 * majitele 7. 9. "plocha zustane bez obsahu", schvalena odchylka, AS
 * DOPLNEK). Puvodne 0.15 bez rootMargin; zrychleno na REVEAL_IO_THRESHOLD
 * + REVEAL_ROOT_MARGIN, aby se sekce odhalila driv po vstupu do viewportu.
 */
const IO_THRESHOLD = REVEAL_IO_THRESHOLD;
const ROOT_MARGIN = REVEAL_ROOT_MARGIN;

/**
 * Jednotny fallback od `init()` pro CELOU stranku (rozhodnuti #15
 * CONTEXT.md, POKYNY radek 82). Ne per sekci: POKYNY zadny per-sekcni
 * timing nerozlisuje a patnact nezavislych casovacu by vyrobilo patnact
 * ruznych okamziku, ktere by slo jen tezko zmerit. Sdileno pres
 * `reveal-timing.js`.
 */
const FALLBACK_MS = REVEAL_FALLBACK_MS;

/**
 * Oznaci jediny prvek za pripraveny.
 *
 * PODMINKA NAVIC (1.27.13, koordinatoruv nalez): `setAttribute()` na
 * STEJNOU hodnotu porad zapisuje MutationObserver zaznam (DOM spec to
 * negarantuje jako no-op, na rozdil od `classList.add()` uz pritomne
 * tridy) -- namereno na homepage 17 ms po resize, `data-reveal-ready`
 * prepsano z "1" na "1". Prvek muze `markReady()` dostat VICEKRAT (IO
 * zaznam i 1,2s fallback muzou obe zavolat pro tentyz prvek, pokud IO
 * nestihne `unobserve` pred fallbackem) -- kontrola tady dela z druheho
 * a dalsiho volani no-op i na urovni DOM zapisu, ne jen vysledne hodnoty.
 *
 * @param {Element} el Cilovy prvek.
 * @return {void}
 */
function markReady(el) {
	if (el.getAttribute(READY_ATTR) !== '1') {
		el.setAttribute(READY_ATTR, '1');
	}
}

/**
 * Spusti reveal system: trida na <html>, IO nad prvky, jednotny fallback.
 *
 * @return {void}
 */
export function init() {
	// PRVNI RADEK, PRED EARLY-RETURNEM: vypina CSS casovy fallback tim, ze
	// oznamuje "modul bezi". Kdyby stal az za `if (!targets.length)`, na
	// strance bez jedineho `.reveal` prvku by fallback bezel navzdy --
	// neskodne, ale byla by to lez o stavu.
	document.documentElement.classList.add(READY_CLASS);

	// `slice.call` misto `NodeList.forEach`: tatáž disciplina jako dock.js
	// (staticke pole, ktere se pod rukama nemeni) a jistota na spodni
	// hranici matice podpory.
	const targets = Array.prototype.slice.call(document.querySelectorAll(TARGET_SELECTOR));
	if (!targets.length) {
		return;
	}

	/*
	 * FALLBACK SE REGISTRUJE DRIV NEZ COKOLI RIZIKOVEHO (08-16b, #69).
	 * Do 08-16b stal az UPLNE NAKONEC funkce: kdyz `new IntersectionObserver()`
	 * nebo `io.observe()` vyhodilo vyjimku, `init()` skoncila DRIV, nez se
	 * timer zaregistroval -- a CSS casovy fallback uz byl vypnuty prvnim
	 * radkem funkce. Vysledek: `.reveal` prvky zustaly `opacity: 0` NAVZDY,
	 * tedy presny opak fail-open kontraktu.
	 *
	 * Bezi VZDY, i kdyz IO existuje: prvek, ktery se nikdy neobjevi ve
	 * vyrezu (navstevnik neodroluje, sekce ve skrytem tabu), by jinak
	 * zustal schovany az do CSS fallbacku, tedy o 0,8 s dele.
	 */
	window.setTimeout(function () {
		targets.forEach(markReady);
	}, FALLBACK_MS);

	/*
	 * A JESTE POJISTKA PRO OKAMZITE ODKRYTI. `setTimeout` vyse resi
	 * "za 1,2 s"; `try/catch` resi "hned ted" -- pri vyjimce nema smysl
	 * cekat vterinu na obsah, ktery uz je jasne, ze se jinak neodkryje.
	 * Trida `reveal-failed` je treti, nezavisla cesta: CSS pravidlo
	 * `html.reveal-failed .reveal { opacity: 1 }` funguje i tehdy, kdyby
	 * `markReady()` samo bylo tim, co hazi.
	 */
	try {
		if (window.IntersectionObserver) {
			const io = new window.IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) {
						return;
					}
					// Odhlaseni hned po odkryti: animace je jednorazova,
					// dalsi protnuti uz nema co zmenit a observer by drzel
					// referenci na kazdou sekci stranky do jejiho zavreni.
					io.unobserve(entry.target);
					// Po zmene vysky viewportu (iOS lista po tapu) pocka, az se
					// ustali (resize-guard.js): odkryti se odlozi, ne zahodi.
					guard(function () {
						markReady(entry.target);
					});
				});
			}, { threshold: IO_THRESHOLD, rootMargin: ROOT_MARGIN });

			targets.forEach(function (el) {
				io.observe(el);
			});
		} else {
			// DEGRADACE "VSE VIDITELNE" (kontrakt B): engine bez IO nema jak
			// zjistit vyrez, takze se neceka vubec na nic. Cekat na 1,2s
			// fallback by na takovem zarizeni znamenalo 1,2 s prazdne stranky.
			targets.forEach(markReady);
		}
	} catch (revealError) {
		// Chyba se dal nikam nehlasi: modul je dekorace, ne funkce webu.
		// Jedine, co se musi stat, je ODKRYT OBSAH -- to je fail-open.
		void revealError;
		document.documentElement.classList.add(FAILED_CLASS);
		targets.forEach(markReady);
	}
}
